import { render, staticRenderFns } from "./issuu-catalogue.vue?vue&type=template&id=3e5b22a6&"
import script from "./issuu-catalogue.vue?vue&type=script&lang=js&"
export * from "./issuu-catalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports